import React, { useState } from 'react';

import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import FilterListIcon from '@mui/icons-material/FilterList';

import SearchTermFilter from 'ff/debrief/components/sidebar/SearchTermFilter';
import DateFilterPopover from 'ff/debrief/components/sidebar/DateFilterPopover';
import { useTheme } from '@mui/material/styles';
import { formatDateRange } from 'ff/debrief/utils';

interface Props {
    startTimestamp: number;
    endTimestamp: number;
    fuzzySearchTerm: string;
    onStartChange: (timestamp: number) => void;
    onEndChange: (timestamp: number) => void;
    onFuzzySearchChange: (term: string) => void;
}

const FilterBar: React.FC<Props> = ({
    startTimestamp,
    endTimestamp,
    fuzzySearchTerm,
    onStartChange,
    onEndChange,
    onFuzzySearchChange,
}) => {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const hasDateFilter = startTimestamp > 0 || endTimestamp > 0;
    const open = Boolean(anchorEl);

    return (
        <Box>
            <Grid container px={0.5} alignItems="center">
                <Grid size={{ xs: 10 }}>
                    <SearchTermFilter
                        fuzzySearchTerm={fuzzySearchTerm}
                        onFuzzySearchChange={onFuzzySearchChange}
                    />
                </Grid>
                <Grid size={{ xs: 2 }} display="flex" justifyContent="flex-end">
                    <IconButton
                        onClick={e => setAnchorEl(e.currentTarget)}
                        size="small"
                        color="primary"
                        sx={{
                            border: `1px solid ${theme.palette.primary.main}`,
                            borderRadius: 1,
                        }}
                    >
                        <FilterListIcon fontSize="small" />
                    </IconButton>
                </Grid>
            </Grid>

            {hasDateFilter && (
                <Box px={0.5} mt={1}>
                    <Chip
                        label={formatDateRange(startTimestamp, endTimestamp)}
                        size="small"
                        variant="outlined"
                        onDelete={() => {
                            onStartChange(undefined);
                            onEndChange(undefined);
                        }}
                    />
                </Box>
            )}

            <DateFilterPopover
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                startTimestamp={startTimestamp}
                endTimestamp={endTimestamp}
                onStartChange={onStartChange}
                onEndChange={onEndChange}
            />
        </Box>
    );
};

export default FilterBar;
